import { useBunja } from 'bunja/react';

import { TradingLeaderboardEvent } from '@flipster/utils/segment/events/trading-leaderboard';

import { SegmentPage } from '../misc/segment/segment-page';
import { intervalLeaderboardBunja } from './bunja';

export const SegmentView = () => {
  const { tier, interval } = useBunja(intervalLeaderboardBunja);
  return <SegmentPage name={TradingLeaderboardEvent.RankingPageView} context={{ tier, interval }} />;
};
